import { useEffect } from 'react';

const ROOT_TITLE = 'AlgoTech';

export function useDocumentTitle(...titles: string[]) {
    useEffect(() => {
        document.title = [ROOT_TITLE, ...titles].reverse().join(' | ');
    }, [titles]);
}
